import { Utils } from '@genial/utils';

export const getUpdatedAt = (date: Date) => {
  const dateNow = Utils.Mask.DateFormat(date, 'dd/MM HH:mm:ss');
  return `Atualizado em ${dateNow}`;
};
